import EventTrackerManager from '../event-tracker-manager'

document.addEventListener('DOMContentLoaded', () => {
  const overrideTimeout = 10
  setTimeout(() => {
    // force websites still using eventGA to migrate to new system
    window.Nematis = {
      forms2GA: {
        // eslint-disable-next-line no-empty-function
        init: () => {
        },
        triggerGA: (...args) => {
          console.warn('Nematis.forms2GA.triggerGA() is deprecated, use EventTrackerManager.sendEvent() instead.')

          // build event params
          const eventParams = {
            category: args[0] ?? 'Category',
            action: args[1] ?? 'Action',
            label: args[2] ?? 'Label'
          }

          EventTrackerManager.sendEvent(eventParams)
        }
      }
    }
  }, overrideTimeout)
})
